import {Injectable} from '@angular/core';
import {AlertController} from '@ionic/angular';
import {ErrorModel} from '../models/error.model';
import {Router} from '@angular/router';
import {constants} from '../constants';

@Injectable({
	providedIn: 'root'
})
export class ErrorsService {
	errorShowing: boolean;

	constructor(private alertController: AlertController,
				private router: Router) {
	}

	private static getErrorCodeMessage(error: ErrorModel): string {
		switch (error.code) {
		case 403:
			return constants.LOGGED_OUT_FOR_INACTIVITY;
		default:
			var message = error.message ? error.message : 'There was an error making the request';
			var otherError = error as any;
			if (otherError.error && otherError.error.message) {
				message = otherError.error.message;
			}
			return message;
		}
	}

	public async handleError(error: ErrorModel) {
		if (error.code === 403) {
			await this.router.navigate(['/login']);
		}

		console.error(error);
		
		if (this.errorShowing) {
			return;
		}
		this.errorShowing = true;
		const alert = await this.alertController.create({
			cssClass: 'my-custom-class',
			header: 'Error',
			message: ErrorsService.getErrorCodeMessage(error),
			buttons: [
				{
					text: 'OK',
					handler: () => {
						this.errorShowing = false;
					}
				}
			]
		});
		await alert.present();
	}
}
